import type { ReactNode } from "react";
import { RecipeImageFallback } from "@/components/RecipeImageFallback";

interface HeroPageLayoutProps {
    coverImageUrl: string;
    headerContent: ReactNode;
    children: ReactNode;
}

export const HeroPageLayout = ({ coverImageUrl, headerContent, children }: HeroPageLayoutProps) => {
    return (
        <div>
            <div className="flex justify-center overflow-clip relative bg-position-[50%] max-h-max xl:h-[84vh] xl:max-h-[calc(100vh-64px)]">
                <div className="w-full relative flex gap-y-10 gap-x-0 xl:gap-x-0 xl:gap-y-0 flex-wrap-reverse xl:flex-nowrap xl:justify-end">
                    <div className="pl-[20px] basis-full xl:basis-[600px] 2xl:basis-[760px] grow-1 xl:grow-0 w-full self-center pr-[28px] xl:pl-[20px] xl:pr-[20px] 2xl:pl-[60px] 2xl:pr-[140px]">
                        {headerContent}
                    </div>
                    <div className="basis-full grow-1 xl:basis-auto xl:grow-0 xl:shrink-0 xl:w-[43vw] self-stretch">
                        <figure className="h-full object-cover w-full min-h-[450px] xl:min-h-0 xl:h-full">
                            {coverImageUrl ? (
                                <img
                                    className="w-full h-[450px] xl:mb-0 xl:h-full object-cover object-center max-w-full align-bottom xl:rounded-bl-md"
                                    src={coverImageUrl}
                                />
                            ) : (
                                <RecipeImageFallback className="w-full h-[450px] min-h-[450px] xl:h-full xl:rounded-bl-md" />
                            )}
                        </figure>
                    </div>
                </div>
            </div>
            <div className="flex flex-col gap-4 mt-10 xl:mt-20">{children}</div>
        </div>
    );
};
